import React, { memo } from "react";
import GraphLegend from "@components/tailwindComponents/GraphLegend";

export default memo(function Legende({
  backgroundColor,
  name,
  className,
  classParagraph
}) {
  return (
    <div className={`${className || ""} arh-flex arh-items-center`}>
      <div
        className="arh-w-3 arh-h-3 arh-mr-2 arh-border-transparent arh-border arh-border-solid arh-shrink-0"
        style={{ background: backgroundColor }}
      ></div>
      <GraphLegend classParagraph={classParagraph}>{name}</GraphLegend>
    </div>
  );
});
